import { useAppDispatch } from "hooks/useAppDispatch";
import { useEffect } from "react";
import {
  registerNoTopPadding,
  unregisterNoTopPadding,
} from "store/slices/appLayout";

export const useDisableContentTopPadding = (enabled = true): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!enabled) return;

    dispatch(registerNoTopPadding());

    return () => {
      dispatch(unregisterNoTopPadding());
    };
  }, [dispatch, enabled]);
};
